import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-sso-auth',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './sso-auth.component.html',
  styleUrls: ['./sso-auth.component.scss'],
})
export class SsoAuthComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);

  readonly launchUrl = signal('');
  readonly requiresManualLaunch = signal(false);

  ngOnInit(): void {
    const params = { ...this.route.snapshot.queryParams };
    const target = params['target'];
    if (!target) {
      return;
    }
    delete params['target'];

    const qs = new URLSearchParams(
      Object.entries(params).reduce<Record<string, string>>((acc, [k, v]) => {
        if (v !== null && v !== undefined) {
          acc[k] = String(v);
        }
        return acc;
      }, {}),
    ).toString();
    const url = qs ? `${target}?${qs}` : target;
    this.launchUrl.set(url);

    if (this.isIosOrIpadOs()) {
      this.requiresManualLaunch.set(true);
      return;
    }

    // Android, desktop web, and everything else: navigate immediately.
    // Use replace so the back button doesn't return to this transit page
    // and re-trigger an already-consumed single-use token.
    window.location.replace(url);
  }

  // iPadOS 13+ Safari reports the platform as Mac with multi-touch enabled,
  // so a simple UA check misses iPad. Detect both cases.
  private isIosOrIpadOs(): boolean {
    if (typeof navigator === 'undefined') {
      return false;
    }
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      return true;
    }
    const platform = navigator.platform ?? '';
    return navigator.maxTouchPoints > 1 && /Mac/i.test(platform);
  }
}
